<template>
  <layout-list-default :meals="meals" />
</template>

<script>
import LayoutListDefault from "./layout-list-default"

export default {
  maxMeals: 13,
  slicer: LayoutListDefault.slicer,
  name: "layout-list-green",
  props: ["meals"],
  components: { LayoutListDefault }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.layout {
  background-color: green;
  ::v-deep .item {
    padding-left: 0.2em;
    padding-right: 0.2em;
  }
  ::v-deep .item:nth-child(even) {
    background-color: rgb(235, 255, 234);
    & .allergens {
      color: gray;
    }
  }
}
</style>
